<template>
    <div class="inside_pages_right">
        <div class="inside_pages_right_top">
           <div class="inside_header_title">报警管理</div>
        </div>
        <div class="inside_pages_right_content">
            <div class="content_top_three ">
                <div class="inside_pages_right_content_top_right ">
                    <el-select v-model="requestData.type" placeholder="请选择告警类型" size="mini">
                        <el-option label="请选择告警类型" value="">
                        </el-option>
                        <el-option v-for="item in $store.state.select.alarmType" :key="item.id" :label="item.nameOne" :value="item.id">
                        </el-option>
                    </el-select>&nbsp;
                    <el-select v-model="requestData.status" placeholder="请选择报警状态" size="mini">
                        <el-option label="选择报警状态" value="">
                        </el-option>
                        <el-option v-for="item in $store.state.select.processingStatus" :key="item.id" :label="item.nameOne" :value="item.id">
                        </el-option>
                    </el-select>&nbsp;
                    <el-button size="mini" type="primary" plain icon="el-icon-search">搜索</el-button>
                </div>
            </div>
            <div class="content_center_three">
                <el-table :data="responseData.list"  height="100%" border style="width: 100%">
                    <el-table-column prop="name1" label="设备ID">
                    </el-table-column>

                    <el-table-column prop="name2" label="安装地点">
                    </el-table-column>

                    <el-table-column prop="name3" label="报警值">
                    </el-table-column>

                    <el-table-column prop="name4" label="报警详情">
                    </el-table-column>

                    <el-table-column prop="date1" label="报警时间">
                    </el-table-column>

                    <el-table-column prop="name5" label="处理状态">
                    </el-table-column>

                    <el-table-column  label="操作" width="300">
                        <template slot-scope="scope">
                            <el-button  type="primary"   size="mini"   icon="el-icon-edit-outline" >
                                编辑
                            </el-button>
                            <el-button  type="danger"   size="mini"   icon="el-icon-delete" >
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="content_bottom_three">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="responseData.pageNum"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="20"
                layout="total, sizes, prev, pager, next, jumper"
                :total="responseData.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'',
    components: {},
    props: {},
    data() {
        return {
            requestData:{
                schoolId:this.$store.state.schoolId,
                pageSize:20,
                pageNum:1,
                status:'',
                type:'',
            },
            responseData:{
                pageSize:20,
                pageNum:1,
                total:100,
                pages:20,
                list:[
                    {
                        id:1,
                        name1: '7A3378DB29F3',
                        name2: '二楼',
                        date1: 1593273599,
                        name3:'1111',
                        name4:'电压过高',
                        name5:'未处理',
                    },
                ],
            },
        };
    },
    watch: {},
    computed: {},
    methods: {
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        }

    },
    created() {},
    mounted() {

    }
};
</script>
